export const CHARGING_MODELS_LINK =
  'https://www.ankr.com/docs/rpc-service/service-plans/#charging-models';

/**
 * The old bundle payment plan model.
 * Some users already have this bundle and are able to prolong it.
 * The id is same on both staging and production.
 */
export const PACKAGE_BUNDLE_ID = '0a5330a5-d420-417e-a99f-fd293ac65eeb';
